import {
  HttpErrorResponse,
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, firstValueFrom, Observable, of, tap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Common } from '../lib/common-methods';
import { LocalStorageService } from '../lib/local-storage.service';
import { UtilsService } from '../lib/utils.service';
import * as AppActions from './../store/actions/app.actions';
import * as AppSelectors from './../store/selectors/app.selectors';

const logoutErrorCodes = ["1000", "1001", "1002", "1003"];
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private utilsService: UtilsService,
    private authService: AuthService,
    private translateService: TranslateService,
    private utilService: UtilsService,
    private store: Store<{}>
  ) { }

  isOffline$: Observable<boolean> = this.store.pipe(select(AppSelectors.selectIsOffline));

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.headers.get('X-Bypass-Interceptor') === 'true') {
      return next.handle(request).pipe(
        catchError(err => {
          // swallow error silently
          return of(err);
        }),
        finalize(() => {
          // still mark request finished
          this.utilService.setRequestIsInProgress(false);
        })
      );
    }


    const isLogoutRequest = request.url?.includes('/logOut');

    return next.handle(request).pipe(
      tap(async (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

          if (event.status === 200) {
            const token = event.headers.get('token');
            if (!Common.isEmpty(token) /*&& response.data.Status === true*/) {
              this.localStorageService.saveServerToken(token as string);
            }
          }

          const ecodeHeader = event.headers.get('ecode');
          if (ecodeHeader != null) {
            if (logoutErrorCodes.includes(ecodeHeader)) {
              // inform
              this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translateService.instant('messages.pleaseTryToLogin') });
              // force logout
              if (!isLogoutRequest) {
                this.authService.logout();
              }
            } else {
              // inform
              this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translateService.instant('messages.somethingWrongHappened') });
            }
            return;
          }

          const isOfflineExistingStatus = await firstValueFrom(this.isOffline$);
          if (isOfflineExistingStatus !== false) {
            this.store.dispatch({ type: AppActions.setIsOffline.type, isOffline: false });
          }

          // if (event?.body?.ErrorCode != null && event.body.ErrorCode.length > 0) {
          //   this.store.dispatch({ type: AppActions.showAlert.type, alert: event.body.ErrorDescription });
          // }
        }
      })
    ).pipe(
      catchError(err => {
        let checkForOffline = true;
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            // inform
            this.store.dispatch({ type: AppActions.showAlert.type, alert: this.translateService.instant('messages.pleaseTryToLogin') });
            // force logout
            if (!isLogoutRequest) {
              this.authService.logout();
            }
            checkForOffline = false;
          }
        }

        if (checkForOffline) {
          //const isOfflineExistingStatus = await firstValueFrom(this.isOffline$);
          const isOffline = this.utilsService.requestFailledDueToNetwork(err);
          //if (isOfflineExistingStatus !== isOffline) {
          this.store.dispatch({ type: AppActions.setIsOffline.type, isOffline });
          //}
        }

        return throwError(() => err);
      }),
      finalize(() => {
        this.utilService.setRequestIsInProgress(false);
        // any cleanup or final activities
      })
    );
  }
}
